module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"name":"Site name","siteUrl":"Site URL","jwt":"JWT token","jwtExpired":"JWT expired","jwtExpires":"JWT expires"}}')
  delete Component.options._Ctor
}
